<template>
   <div>
      <input
         :class="color"
         class="checkbox-input"
         type="checkbox"
         :id="id"
         :checked="checked"
         :disabled="disabled"
         @click="evt => $emit('click',evt)"
      />
      <label tabindex="0" :for="id" >
         <!-- <div class="pseudo-checkbox">
            <div class="pseudo-checkbox-checkmark">
               &#128504;
            </div>
         </div> -->
         <atom-text v-if="label" class='label-text'>{{ label }}</atom-text>
      </label>
   </div>
</template>

<script>
import AtomText from '../../../atoms/Login/Text';

export default {
   props: {
      color: {
         type: String,
         default: 'dark',
         validator: value => [ "primary","success","info","dark","danger"].includes(value)
      },
      id: {
         type: String,
         required: true,
      },
      checked: {
         type: Boolean,
         default: false,
      },
      disabled: {
         type: Boolean,
         default: false,
      },
      label: {
         type: String,
         default: '',
      }
   },
   components: {
      AtomText,
   },
};
</script>

<style lang="scss" scoped>
@mixin setTheme($color)
{
   & + label
   {  
      &::before
      {
         border: 1px solid $secondary-color;
         background-color: white;
         box-shadow: inset 0 1px 2px rgba(0,0,0,0.1),
            0 0 3px rgba($color, 0.2);

         &:hover, &:focus
         {
            $lightened-color: $color;
            @if (lightness($color) < 50%)
            {
               $lightened-color: lighten($color, 20%);
            }
            box-shadow: inset 0 1px 2px rgba(0,0,0,0.2),
               1px 1px 3px rgba($lightened-color, 0.4);
         }
      }
      &::after
      {
         color: white;
         @if (lightness($color) > 60%)
         {
            color: $secondary-color;
         }
      }

   }

   &:checked {
      & + label {
         &::before {
            background-color: $color;
            border-color: $color;
         }
         &::after {
            transform: scale(1) rotate(0deg) translate(1px, 1px);
         }
      }
   }
   &:disabled + label{
      .label-text {
         color: lighten($font-color, 15%);
      }
      &::before {
         background-color: lighten($secondary-color,10%);
         border-color: lighten($secondary-color,10%);
         box-shadow: 1px 1px 2px rgba(0,0,0,0.1);
      }
      &::after {
         color: darken(white,10%);
      }
   }
}

.checkbox-input {
   display: none;

   & + label {
      cursor: pointer;
      display: flex;
      align-items: flex-start;
      margin: 0;
      padding: 0;

      &::before, &::after {
         content: " ";
         margin-top: 3.5px;
         margin-right: 4px;
         width: 15px !important;
         height: 15px !important;
         border-radius: 25%;
         transition: all 0.4s ease;
      }
      &::after {
         content: '\01F5F8';
         position: absolute;
         color: white;
         display: flex;
         justify-content: center;
         align-items: center;
         font-size: 13px;
         transform: scale(0) rotate(-180deg) translate(1px, 1px);
      }
      .label-text {
         display: inline;
         margin: 0;
         font-size: 0.9em;
      }
   }
   &.primary { @include setTheme(lighten($primary-color, 5%)); }
   &.success { @include setTheme($success-color); }
   &.info { @include setTheme($info-color); }
   &.dark { @include setTheme(lighten($dark-color, 10%)); }
   &.danger { @include setTheme($danger-color); }
}

</style>